<template>
  <div class="grid grid-cols-4 gap-x-4 gap-y-4 py-1">
    <FileItemCard
      v-for="(attachment, index) in attachments"
      :key="attachment.id"
      :is-image="isTypeImage(attachment.resource)"
      :image-src="attachment.thumb"
      :file-name="fileName(attachment.resource)"
      :file-size="
        hasFileSize(attachment.resource)
          ? formatFileSize(attachment.resource)
          : ''
      "
      :extension="
        getFileExtension(
          attachment.resource.filename || attachment.resource.name
        )
      "
      :icon-color-class="
        getFileIconColor(
          attachment.resource.content_type || attachment.resource.type,
          getFileExtension(
            attachment.resource.filename || attachment.resource.name
          )
        )
      "
    >
      <template v-if="!readonly" #action>
        <span
          class="material-symbols-outlined remove--attachment text-gray-500 text-base/[16px]"
          @click.prevent="() => onRemoveAttachment(index)"
        >
          close
        </span>
      </template>
    </FileItemCard>
    <div
      v-for="progress in progresses"
      :key="progress.id"
      class="progress-item__wrap"
    >
      {{ progress.name }}
      <div
        class="progress-item"
        :style="{ width: `${progress.value * 100}%` }"
      />
    </div>
  </div>
</template>
<script>
import { formatBytes } from 'shared/helpers/FileHelper';
import FileItemCard from 'dashboard/components/widgets/FileItemCard.vue';
import { getFileExtension, getFileIconColor } from 'dashboard/helper/fileUtils';

export default {
  components: { FileItemCard },
  props: {
    attachments: {
      type: Array,
      default: () => [],
    },
    removeAttachment: {
      type: Function,
      default: () => {},
    },
    progresses: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getFileExtension,
    getFileIconColor,
    onRemoveAttachment(index) {
      this.removeAttachment(index);
    },
    formatFileSize(file) {
      const size = file.byte_size || file.size;
      return formatBytes(size, 0);
    },
    hasFileSize(file) {
      return file.size || file.byte_size;
    },
    isTypeImage(file) {
      const type = file.content_type || file.type;
      return type.includes('image');
    },
    fileName(file) {
      return file.filename || file.name;
    },
  },
};
</script>
<style lang="scss" scoped>
.remove--attachment {
  @apply flex items-center justify-center rounded-[4px] cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800;
}

// d99d
.progress-item__wrap {
  background: var(--s-25);
  border-radius: var(--border-radius-normal);
  color: var(--b-300);
  width: 24rem;
  padding: var(--space-smaller);
  margin-bottom: var(--space-one);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--font-size-mini);
}
.progress-item {
  width: 1%;
  height: 2px;
  background-color: green;
}
// .
</style>
